import { useEffect, useRef } from "react";

export type UseHeaderBuilderStyleProps = {
  headerPortalHeight: number;
  isVisibleOverlay: boolean;
  isOverlayHeader: boolean;
  isTransitionDisabled: boolean;
  isHidden: boolean;
  isVisible: boolean;
  styles: Record<string, string>;
};

export const useBuilderHeaderStyle = ({
  headerPortalHeight,
  isVisible,
  isVisibleOverlay,
  isHidden,
  isOverlayHeader,
  isTransitionDisabled,
  styles,
}: UseHeaderBuilderStyleProps): boolean => {
  const headerRef = useRef<HTMLElement | null>(null);
  const isBuilderStyleSkipped = headerRef.current === null;

  useEffect(() => {
    const headerBuilderWrapper = document.querySelector<HTMLElement>('[builder-model="header"]');
    if (headerBuilderWrapper) {
      headerRef.current = headerBuilderWrapper;
      headerBuilderWrapper.classList.add(styles.headerPosition);
    }
  }, [headerPortalHeight, styles]);

  useEffect(() => {
    if (headerRef.current) {
      headerRef.current.classList.toggle(styles.hidden, isHidden);
      headerRef.current.classList.toggle(styles.visible, isVisible);
      headerRef.current.classList.toggle(styles.fixed, isOverlayHeader);
      headerRef.current.classList.toggle(styles.visibleAsOverlay, isVisibleOverlay);
      headerRef.current.classList.toggle(styles.transitionDisabled, isTransitionDisabled);
    }
  }, [isHidden, isOverlayHeader, isTransitionDisabled, isVisible, isVisibleOverlay, styles]);

  return isBuilderStyleSkipped;
};
